export default {
  company: "Company",
  share_holder: "Share Holder",
  super_senior: "Super Senior",
  senior: "Senior",
  master: "Master",
  agent: "Agent",
  member: "Member",

  account_id: "Username",
  action: "Action",
  available_credit: "Available Credit",
  active: "Active",
  account_balance: "Account Balance",
  agent_credit: "Agent Credit",
  authority: "Authority",
  account_information: "Account Information",
  account_list: "Account List",
  audit_by: "Audit By",
  add_account: "Add Account",
  add_sub_account: "Add Sub Account",
  authority_option: "Authority Options",
  account: "Account",
  access_log: "Access Log",
  account_log: "Account Log",
  account_details: "Account Details",
  action_by: "Action By",
  away_team_name: "Away Team Name",
  amount: "Amount",
  account_before_balance: "Account Before Balance",
  account_after_balance: "Account After Balance",
  active_bet_list: "Active Bet List",
  agent_win_all: "Agent Win All",
  agent_win_half: "Agent Win Half",
  agent_lose_all: "Agent Lose All",
  agent_lose_half: "Agent Lose Half",
  accumulate_win: "Accumulated Win",
  add_sub: "Add Sub-account",
  account_type: "Account Type",
  account_pt: "Account PT",
  account_min: "Account Min",
  away_score: "Away Score",
  add_secondary_full: "Add Secondary Account",
  accumulate_balance: "Accumulate Balance",
  away: "Away",
  aa: "HT: Away | FT: Away",
  ad: "HT: Away | FT: Draw",
  ah: "HT: Away | FT: Home",
  anb: "Away No Bet",
  all: "All",
  account_existed: "Account existed.",
  account_not_existed: "Account not existed.",
  account_status: "Account Status",
  account_block: "Account Block",
  account_unblock: "Account Unblock",
  add_secondary: "Add Secondary Account",
  agent_bulk: "Agent Bulk",
  abandoned: "Abandoned",
  account_list_alert: "Player Alert",
  adjustment: "Adjustment",

  balance: "Balance",
  bet: "Bet",
  block: "Block",
  blocked: "Blocked",
  back: "Back",
  bet_limit: "Bet Limit",
  basketball: "Basketball",
  baseball: "Baseball",
  bet_limit_log: "Bet Limit Log",
  browser_agent: "Browser Agent",
  bet_limit_packages: "Bet Limit Packages",
  ball: "Ball",
  bet_count: "Bet Count",
  bet_type: "Bet Type",
  bl: "Bet Limit",
  basketball_min_bet: "@:ui.basketball @:ui.min_bet",
  basketball_max_bet: "@:ui.basketball @:ui.max_bet",
  basketball_max_per_match: "@:ui.basketball @:ui.max_per_match",
  baseball_min_bet: "@:ui.baseball @:ui.min_bet",
  baseball_max_bet: "@:ui.baseball @:ui.max_bet",
  baseball_max_per_match: "@:ui.baseball @:ui.max_per_match",
  bet_list: "Bet List",
  bet_list_4d: "Bet List 4D",
  bet_list_esports2: "Bet List ESports2",
  bs: "Both To Score",

  credit: "Credit",
  cm: "Commission",
  close: "Close",
  cancel: "Cancel",
  continue: "Continue",
  created_on: "Created On",
  copy_and_create: "Copy And Create",
  copy: "Copy",
  confirm_password: "Confirm Password",
  confirm_security_code: "Confirm Security Code",
  contact_phone: "Phone",
  contact_email: "Email",
  cash_balance: "Cash Balance",
  currency: "Currency",
  credit_limit: "Credit Limit",
  credit_balance: "Credit/Balance",
  commission: "Commission",
  correct_score: "Correct Score",
  correct_score_bl: "Correct Score (@:ui.soccer)",
  commission_log: "Commission Log",
  current_balance: "Current Balance",
  cancelled_bet_list: "Cancelled Bet List",
  category: "Category",
  copy_to_bottom: "Copy to Bottom",
  comm_sportsbook_hdp_a: "HDP A",
  comm_sportsbook_hdp_b: "HDP B",
  comm_sportsbook_hdp_c: "HDP C",
  comm_sportsbook_hdp_d: "HDP D",
  comm_sportsbook_hdp_e: "HDP E",
  comm_sportsbook_hdp_f: "HDP F",
  comm_sportsbook_hdp_g: "HDP G",
  comm_sportsbook_hdp_h: "HDP H",
  comm_sportsbook_hdp_i: "HDP I",
  comm_sportsbook_hdp_j: "HDP J",
  comm_sportsbook_1x2: "1X2",
  comm_sportsbook_others: "Others",
  comm_sportsbook_hdp_packages: "HDP Packages",
  comm_slots: "Slots",
  comm_casino: "Live Casino",
  comm_lotto: "Lotto",
  comm_keno: "Keno",
  comm_cockfight: "ESports2",
  comm_lottery_1d: "Lottery 1D",
  comm_lottery_2d: "Lottery 2D",
  comm_lottery_3d: "Lottery 3D",
  comm_lottery_4d: "Lottery 4D",
  comm_tournament: "Tournament",
  completed: "Completed",
  clean_sheet: "Clean Sheet",
  cockfight: "ESports2",
  esports2: "ESports2",
  cockfight_bet_limit_packages: "ESports2 Bet Limit Packages",
  combination: "Combination",
  cs_min_bet: "@:ui.correct_score @:ui.min_bet",
  cs_max_bet: "@:ui.correct_score @:ui.max_bet",
  cs_max_per_match: "@:ui.correct_score @:ui.max_per_match",

  combine: {
    bet_limit_A: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_B: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_C: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_D: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_E: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_F: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_G: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    // bet_limit_AUDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    // bet_limit_AUDB: "Limit B (@:ui.min = 1 @:ui.max = 125)",
    // bet_limit_AUDC: "Limit C (@:ui.min = 1 @:ui.max = 400)",
    // bet_limit_AUDD: "Limit D (@:ui.min = 5 @:ui.max = 1,500)",
    // bet_limit_AUDE: "Limit E (@:ui.min = 5 @:ui.max = 2,500)",
    // bet_limit_AUDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    // bet_limit_AUDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",

    bet_limit_KRWA: "Limit A (@:ui.min = 1,500 @:ui.max = 200,000)",
    bet_limit_KRWB: "Limit B (@:ui.min = 2,000 @:ui.max = 200,000)",
    bet_limit_KRWC: "Limit C (@:ui.min = 2,000 @:ui.max = 400,000)",
    bet_limit_KRWD: "Limit D (@:ui.min = 4,000 @:ui.max = 800,000)",
    bet_limit_KRWE: "Limit E (@:ui.min = 4,000 @:ui.max = 2,000,000)",
    bet_limit_KRWF: "Limit F (@:ui.min = 4,000 @:ui.max = 4,000,000)",
    bet_limit_KRWG: "Limit G (@:ui.min = 4,000 @:ui.max = 6,000,000)",

    bet_limit_CNYA: "Limit A (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CNYB: "Limit B (@:ui.min = 10 @:ui.max = 1000)",
    bet_limit_CNYC: "Limit C (@:ui.min = 10 @:ui.max = 2000)",
    bet_limit_CNYD: "Limit D (@:ui.min = 20 @:ui.max = 5000)",
    bet_limit_CNYE: "Limit E (@:ui.min = 20 @:ui.max = 10000)",
    bet_limit_CNYF: "Limit F (@:ui.min = 400 @:ui.max = 20000)",
    bet_limit_CNYG: "Limit G (@:ui.min = 20 @:ui.max = 50000)",

    bet_limit_HKDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_HKDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_HKDC: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_HKDD: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_HKDE: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_HKDF: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_HKDG: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_SGDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_SGDB: "Limit B (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_SGDC: "Limit C (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_SGDD: "Limit D (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_SGDE: "Limit E (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_SGDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_SGDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",
    
    bet_limit_VNDA: "Limit A (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_VNDB: "Limit B (@:ui.min = 10 @:ui.max = 3,000)",
    bet_limit_VNDC: "Limit C (@:ui.min = 40 @:ui.max = 5,000)",
    bet_limit_VNDD: "Limit D (@:ui.min = 80 @:ui.max = 25,000)",
    bet_limit_VNDE: "Limit E (@:ui.min = 80 @:ui.max = 50,000)",
    bet_limit_VNDF: "Limit F (@:ui.min = 80 @:ui.max = 100,000)",
    bet_limit_VNDG: "Limit G (@:ui.min = 80 @:ui.max = 150,000)",
	
	  bet_limit_MYRA: "Limit A (@:ui.min = 1 @:ui.max = 500)",
    bet_limit_MYRB: "Limit B (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_MYRC: "Limit C (@:ui.min = 10 @:ui.max = 1,000)",
    bet_limit_MYRD: "Limit D (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_MYRE: "Limit E (@:ui.min = 100 @:ui.max = 5,000)",
    bet_limit_MYRF: "Limit F (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MYRG: "Limit G (@:ui.min = 500 @:ui.max = 20,000)",
	
	  bet_limit_USDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_USDB: "Limit B (@:ui.min = 1 @:ui.max = 125)",
    bet_limit_USDC: "Limit C (@:ui.min = 1 @:ui.max = 400)",
    bet_limit_USDD: "Limit D (@:ui.min = 5 @:ui.max = 1,500)",
    bet_limit_USDE: "Limit E (@:ui.min = 5 @:ui.max = 2,500)",
    bet_limit_USDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_USDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",
	
	  bet_limit_THBA: "Limit A (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_THBB: "Limit B (@:ui.min = 50 @:ui.max = 5,000)",
    bet_limit_THBC: "Limit C (@:ui.min = 100 @:ui.max = 10,000)",
    bet_limit_THBD: "Limit D (@:ui.min = 100 @:ui.max = 50,000)",
    bet_limit_THBE: "Limit E (@:ui.min = 100 @:ui.max = 100,000)",
    bet_limit_THBF: "Limit F (@:ui.min = 100 @:ui.max = 200,000)",
    bet_limit_THBG: "Limit G (@:ui.min = 100 @:ui.max = 300,000)",
	
	  bet_limit_IDRA: "Limit A (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_IDRB: "Limit B (@:ui.min = 20 @:ui.max = 1,500)",
    bet_limit_IDRC: "Limit C (@:ui.min = 20 @:ui.max = 3,000)",
    bet_limit_IDRD: "Limit D (@:ui.min = 25 @:ui.max = 15,000)",
    bet_limit_IDRE: "Limit E (@:ui.min = 25 @:ui.max = 30,000)",
    bet_limit_IDRF: "Limit F (@:ui.min = 25 @:ui.max = 60,000)",
    bet_limit_IDRG: "Limit G (@:ui.min = 25 @:ui.max = 100,000)",

    bet_limit_MMKA: "Limit A (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_MMKB: "Limit B (@:ui.min = 2 @:ui.max = 200)",
    bet_limit_MMKC: "Limit C (@:ui.min = 2 @:ui.max = 500)",
    bet_limit_MMKD: "Limit D (@:ui.min = 2 @:ui.max = 1,000)",
    bet_limit_MMKE: "Limit E (@:ui.min = 4 @:ui.max = 2,000)",
    bet_limit_MMKF: "Limit F (@:ui.min = 4 @:ui.max = 5,000)",
    bet_limit_MMKG: "Limit G (@:ui.min = 4 @:ui.max = 10,000)",
    
    bet_limit_MMOA: "Limit A (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_MMOB: "Limit B (@:ui.min = 2 @:ui.max = 200)",
    bet_limit_MMOC: "Limit C (@:ui.min = 2 @:ui.max = 500)",
    bet_limit_MMOD: "Limit D (@:ui.min = 2 @:ui.max = 1,000)",
    bet_limit_MMOE: "Limit E (@:ui.min = 4 @:ui.max = 2,000)",
    bet_limit_MMOF: "Limit F (@:ui.min = 4 @:ui.max = 5,000)",
    bet_limit_MMOG: "Limit G (@:ui.min = 4 @:ui.max = 10,000)",

    bet_limit_ARSA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_ARSB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_ARSC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_ARSD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_ARSE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_ARSF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_ARSG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_AUDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_AUDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_AUDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_AUDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_AUDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_AUDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_AUDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BDTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BDTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BDTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BDTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BDTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BDTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BDTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BNDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BNDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BNDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BNDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BNDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BNDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BNDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BRLA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BRLB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BRLC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BRLD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BRLE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BRLF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BRLG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_EURA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_EURB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_EURC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_EURD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_EURE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_EURF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_EURG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_GOOA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_GOOB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_GOOC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_GOOD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_GOOE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_GOOF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_GOOG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_INRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_INRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_INRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_INRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_INRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_INRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_INRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_JPYA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_JPYB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_JPYC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_JPYD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_JPYE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_JPYF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_JPYG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NPRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NPRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NPRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NPRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NPRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NPRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NPRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PKRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PKRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PKRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PKRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PKRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PKRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PKRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_TNDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_TNDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_TNDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_TNDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_TNDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_TNDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_TNDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_USTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_USTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_USTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_USTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_USTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_USTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_USTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PHPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PHPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PHPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PHPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PHPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PHPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PHPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_LAKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_LAKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_LAKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_LAKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_LAKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_LAKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_LAKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_LKRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_LKRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_LKRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_LKRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_LKRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_LKRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_LKRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_KHRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_KHRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_KHRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_KHRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_KHRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_KHRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_KHRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_AEDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_AEDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_AEDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_AEDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_AEDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_AEDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_AEDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_CADA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_CADB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CADC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_CADD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_CADE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_CADF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_CADG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_CHFA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_CHFB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CHFC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_CHFD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_CHFE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_CHFF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_CHFG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_DKKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_DKKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_DKKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_DKKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_DKKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_DKKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_DKKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_GBPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_GBPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_GBPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_GBPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_GBPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_GBPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_GBPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_MXNA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_MXNB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_MXNC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_MXND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_MXNE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MXNF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_MXNG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NGNA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NGNB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NGNC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NGND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NGNE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NGNF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NGNG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NOKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NOKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NOKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NOKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NOKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NOKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NOKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NZDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NZDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NZDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NZDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NZDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NZDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NZDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_RUBA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_RUBB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_RUBC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_RUBD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_RUBE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_RUBF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_RUBG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_SEKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_SEKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_SEKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_SEKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_SEKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_SEKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_SEKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_TRYA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_TRYB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_TRYC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_TRYD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_TRYE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_TRYF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_TRYG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_ZARA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_ZARB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_ZARC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_ZARD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_ZARE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_ZARF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_ZARG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_COPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_COPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_COPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_COPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_COPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_COPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_COPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PENA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PENB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PENC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PEND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PENE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PENF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PENG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_MNTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_MNTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_MNTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_MNTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_MNTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MNTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_MNTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_KESA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_KESB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_KESC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_KESD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_KESE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_KESF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_KESG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_PGKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PGKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PGKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PGKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PGKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PGKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PGKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_lottery_MYRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_AUDA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_CNYA: "Package A (@:m.D_BIG:100 @:m.D_SMALL:100 SA:40 @:ui.min:2)",
    bet_limit_lottery_HKDA: "Package A (@:m.D_BIG:100 @:m.D_SMALL:100 SA:40 @:ui.min:2)",
    bet_limit_lottery_IDRA: "Package A (@:m.D_BIG:150 @:m.D_SMALL:150 SA:60 @:ui.min:3)",
    bet_limit_lottery_KRWA: "Package A (@:m.D_BIG:13000 @:m.D_SMALL:13000 SA:5000 @:ui.min:300)",
    bet_limit_lottery_SGDA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_THBA: "Package A (@:m.D_BIG:500 @:m.D_SMALL:500 SA:200 @:ui.min:10)",
    bet_limit_lottery_USDA: "Package A (@:m.D_BIG:10 @:m.D_SMALL:10 SA:5 @:ui.min:1)",
    bet_limit_lottery_VNDA: "Package A (@:m.D_BIG:250 @:m.D_SMALL:250 SA:100 @:ui.min:5)",
    bet_limit_lottery_MMKA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_MMOA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",

    bet_limit_lottery_ARSA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BDTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BNDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BRLA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_EURA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_GOOA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_INRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_JPYA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NPRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PKRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_TNDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_USTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PHPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_LAKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_LKRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_KHRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_AEDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_CADA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_CHFA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_DKKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_GBPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_MXNA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NGNA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NOKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NZDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_RUBA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_SEKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_TRYA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_ZARA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_COPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PENA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_MNTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_KESA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PGKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",

    comm_limit_A: "Group A",
    comm_limit_B: "Group B",
    comm_limit_C: "Group C",
    comm_limit_D: "Group D",
    comm_limit_E: "Group E",
    comm_limit_F: "Group F",
    comm_limit_G: "Group G",
    comm_limit_H: "Group H",
    comm_limit_I: "Group I",
    comm_limit_J: "Group J",

    comm_parlay_mmo_a: "Parlay MMO (2-3)",
    comm_parlay_mmo_b: "Parlay MMO (4-12)",

    reset_password: "@:ui.reset @:ui.password",
    edit_password: "@:ui.edit @:ui.password",
    edit_settings: "@:ui.edit @:ui.settings",
    edit_profile: "@:ui.edit @:ui.profile",
    edit_authority: "@:ui.edit @:ui.authority",
    update_commission: "@:ui.update @:ui.commission",
    update_bet_limit: "@:ui.update @:ui.bet_limit",
    update_position_taking: "@:ui.update @:ui.position_taking",
    update_profile: "@:ui.update @:ui.profile"
  },

  downline_id: "Downline ID",
  disabled: "Disabled",
  downline: "Downline",
  dashboard: "Dashboard",
  downline_list: "Downline List",
  double_chance: "Double Chance",
  downline_credit: "Downline Credit",
  date: "Date",
  data: "Data",
  date_time: "Date/Time",
  date_range: "Date Range",
  details: "Details",
  draw: "Draw",
  daily_statement: "Statement",
  daily_statement_member: "Member Statement",
  daily_winlose: "Daily Win Lose",
  daily_winlose_simple: "Win Lose Simple",
  daily_winlose_details: "Win Lose",
  daily_reset: "Daily Reset",
  daily_winlose_platform: "Win Lose By Product",
  daily_winlose_match: "Win Lose By Match",
  detail: "Detail",
  downline_outstanding: "Downline Outstanding",
  dd: "HT: Draw | FT: Draw",
  dh: "HT: Draw | FT: Home",
  da: "HT: Draw | FT: Away",
  dnb: "Draw No Bet",
  draw_cancel: "Draw",
  default: "Default",
  deposit: "Deposit",

  edit: "Edit",
  enter_information: "Enter Information",
  enable: "Enable",
  esports: "E-Sports",
  edit_account: "Edit Account",
  edit_limit: "Edit Limit",
  early: "Early",
  event: "Event",
  enabled: "Enabled",
  esports_min_bet: "@:ui.esports @:ui.min_bet",
  esports_max_bet: "@:ui.esports @:ui.max_bet",
  esports_max_per_match: "@:ui.esports @:ui.max_per_match",
  even: "Even",
  edited: "Edited",
  export_excel: "Export Excel",

  from: "From",
  full: "Full",

  forecast: "Forecast",
  forecast_soccer: "Forecast (Soccer)",
  freeze: "Freeze",
  full_name: "Name",
  full_mode: "Full Mode",
  first_hdp: "1st Hdp",
  first_ou: "1st OU",
  fh: "FH",
  forecast_details: "Forecast Details",
  full_time: "Full Time",
  fglg: "@:m.BT_FG/@:m.BT_LG",
  first_goal: "First Goal",
  first_half: "First Half",
  fold: "Fold",

  grand_total: "Grand Total",
  gross_commission: "Gross Comm",
  game_name: "Game Name",
  game_provider: "Game Provider",
  game_result: "Game Result",
  game_result_details: "Game Result Details",
  gross_winlose: "Gross Win Lose",
  game_type: "Game Type",
  game_rules: "Slots Game Rules",
  game_rules_title1: "",
  game_rules_content1: "",

  ht: "HT",
  half: "Half",
  half_time: "Half Time",
  home: "Home",
  hdp: "HDP",
  hdp_packages: "HDP Packages",
  home_team_name: "Home Team Name",
  home_score: "Home Score",
  hh: "HT: Home | FT: Home",
  hd: "HT: Home | FT: Draw",
  ha: "HT: Home | FT: Away",
  hdpou: "@:ui.hdp/@:ui.ou",
  htft: "@:ui.half_time/@:ui.full_time",
  hnb: "Home No Bet",

  ip_address: "IP Address",
  id: "ID",

  jackpot: "Jackpot",

  key: "Key",
  keno: "Keno",
  keno_bet_limit_packages: "Keno Bet Limit Packages",

  log_id: "Log ID",
  lottery: "Lottery",
  lottery_1d: "Lottery 1D",
  lottery_2d: "Lottery 2D",
  lottery_3d: "Lottery 3D",
  lottery_4d: "Lottery 4D",
  lotto: "Lotto",
  log: "Log",
  list: "List",
  logs: "Logs",
  login: "Login",
  logout: "Logout",
  login_ip: "Login IP",
  login_id: "Login ID",
  last_name: "Last name",
  live_casino: "Live Casino",
  livecasino: "Live Casino",
  lastweek: "Last Week",
  lastmonth: "Last Month",
  last3month: "Last 3 Months",
  league_id: "League ID",
  league_name: "League Name",
  league: "League",
  livecasino_platform: "Livecasino Platform",
  livecasino_upline_pt : "@:ui.live_casino @:ui.upline_pt",
  livecasino_account_pt : "@:ui.live_casino @:ui.account_pt",
  livecasino_upline_remaining : "@:ui.live_casino @:ui.upline_remaining",
  livecasino_account_min : "@:ui.live_casino @:ui.account_min",
  livecasino_bet_limit_packages: "Livecasino Bet Limit Packages",
  last_goal: "Last Goal",
  live: "Live",
  lose: "Lose",
  lose_half: "Lose Half",
  last_week: "Last Week",
  last_month: "Last Month",
  lotto_bet_limit_packages: "Lotto Bet Limit Packages",
  lottery_bet_limit_packages: "Lottery Bet Limit Packages",

  member_log: "Member Log",
  member_balance: "Member Balance",
  master_credit: "Master Credit",
  member_credit_limit: "Member Credit Limit",
  max_credit_limit: "Max Credit Limit",
  min_max_bet: "Min/Max Bet",
  min_bet: "Min Bet",
  max_bet: "Max Bet",
  max_per_match: "Max Per Match",
  mix_parlay: "Mix Parlay",
  mmo_parlay: "Myanmar Parlay",
  money_line: "Money Line",
  min: "Min",
  max: "Max",
  market_type: "Market Type",
  match_time: "Match Time",
  match_id: "Match ID",
  member_id: "Username",
  match: "Match",
  master_outstanding: "Master Outstanding",
  mode: "Mode",
  member_outstanding: "Member Outstanding",
  member_outstanding_4d: "Member Outstanding 4D",
  match_result: "Match Result",
  messages: "Messages",
  message: "Message",
  member_management: "Member Mgmt",
  member_bulk: "Member Bulk",
  manila_nocomm: "Game Play & Pretty Gaming & Evolution & Pragmatic & Sexy Gaming Livecasino 0% Commission",
  m4d: "4D",
  marketing_tools: "Marketing Tools",
  min_credit: "Minimum Credit",

  new: "New",
  new_login_id: "New Login ID",
  new_username: "New Username",
  new_password: "New Password",
  new_security_code: "New Security Code",
  new_account: "New Account",
  next: "Next",
  no_goal: "No Goal",
  "no/": "No.",
  normal: "Normal",
  normal_announcements: "Normal Announcements",

  on: "ON",
  off: "OFF",
  ok: "OK",
  over: "Over",
  overview: "Overview",
  old_password: "Old Password",
  outstanding: "Outstanding",
  outstanding_balance: "Outstanding Balance",
  over_under: "Over/Under",
  odd_even: "Odd/Even",
  ou: "OU",
  oe: "OE",
  others: "Others",
  odd: "Odd",
  oxt: "1X2",
  outright: "Outright",
  others_min_bet: "@:ui.others @:ui.min_bet",
  others_max_bet: "@:ui.others @:ui.max_bet",
  others_max_per_match: "@:ui.others @:ui.max_per_match",
  odds_display: "Odds Display",
  online_player: "Online Player",
  opening_balance: "Opening Balance",
  oxtoeml: "@:ui.oe/@:m.BT_1X2/@:m.BT_ML",
  oxthdp: "3 Ways Handicap",
  others_sports: "Other Sports",

  pending: "Pending",
  platform: "Platform",
  pt: "Position Taking",
  password: "Password",
  profile_id: "Profile ID",
  parent_id: "Parent ID",
  page_size: "Page size",
  profile: "Profile",
  payment_option: "Payment Option",
  part_one: "Part One",
  part_two: "Part Two",
  position_taking: "Position Taking",
  preview_settings: "Preview Settings",
  preview: "Preview",
  parlay: "Parlay",
  position_taking_log: "Position Taking Log",
  platform_code: "Platform Code",
  platform_name: "Platform Name",
  pay: "Pay | Pay All",
  payout: "Payout",
  product: "Product",
  pending_matches: "Pending Matches",
  pt_share: "Position Shares",
  platform_settings: "Platform Settings",
  parlay_min_bet: "@:ui.parlay @:ui.min_bet",
  parlay_max_bet: "@:ui.parlay @:ui.max_bet",
  parlay_max_per_match: "@:ui.parlay @:ui.max_per_match",
  parlay_upline_pt : "@:ui.parlay @:ui.upline_pt",
  parlay_account_pt : "@:ui.parlay @:ui.account_pt",
  parlay_upline_remaining : "@:ui.parlay @:ui.upline_remaining",
  parlay_account_min : "@:ui.parlay @:ui.account_min",
  parlay_mmo_upline_pt : "Parlay MMO @:ui.upline_pt",
  parlay_mmo_account_pt : "Parlay MMO @:ui.account_pt",
  parlay_mmo_upline_remaining : "Parlay MMO @:ui.upline_remaining",
  parlay_mmo_account_min : "Parlay MMO @:ui.account_min",
  personal: "Personal",
  personal_message: "Personal Message",
  password_reset: "Password Reset",
  password_update: "Password Update",

  refresh: "Refresh",
  reset: "Reset",
  remaining_credit: "Remaining Credit",
  remaining: "Remaining",
  rate: "Rate",
  report: "Report",
  running: "Running",
  remark: "Remark",
  refund: "Refund",
  range: "Range",
  reject: "Reject",
  reset_accumulate_win: "Reset Accumulated Win",
  refno: "Ref No.",
  result: "Result",
  room_1: "Public",
  room_2: "Private",
  room_3: "Public (Free)",

  status: "Status",
  succeed: "Succeed",
  submit: "Submit",
  settings: "Settings",
  save: "Save",
  search: "Search",
  suspend: "Suspend",
  security_tag: "Security Tag",
  sub_account: "Sub Account",
  search_and_copy: "Search And Copy",
  search_existing: "Search Existing",
  skip: "Skip",
  settings_limit: "Settings Limit",
  sportsbook: "Sportsbook",
  slot_games: "Slot Games",
  soccer: "Soccer",
  sport_types: "Sport Types",
  settlement: "Settlement",
  submatch_id: "Sub-match ID",
  score: "Score",
  submatch_code: "Sub-match Code",
  settlement_list: "Settlement List",
  sub_total: "Sub Total",
  settle_amount: "Settlement Amount",
  settlement_history: "Settlement History",
  // settlement_member: "Member Settlement Details",
  sport_type: "Sport Type",
  slot_platform: "Slots Platform",
  simple_report: "Simple Report",
  status_update: "Update Status",
  set_authority: "Set Authority",
  soccer_hdp_upline_pt : "@:ui.soccer @:ui.hdp @:ui.upline_pt",
  soccer_hdp_account_pt : "@:ui.soccer @:ui.hdp @:ui.account_pt",
  soccer_hdp_upline_remaining : "@:ui.soccer @:ui.hdp @:ui.upline_remaining",
  soccer_hdp_account_min : "@:ui.soccer @:ui.hdp @:ui.account_min",
  soccer_1x2_upline_pt : "@:ui.soccer @:ui.oxt @:ui.upline_pt",
  soccer_1x2_account_pt : "@:ui.soccer @:ui.oxt @:ui.account_pt",
  soccer_1x2_upline_remaining : "@:ui.soccer @:ui.oxt @:ui.upline_remaining",
  soccer_1x2_account_min : "@:ui.soccer @:ui.oxt @:ui.account_min",
  soccer_others_upline_pt : "@:ui.soccer @:ui.others @:ui.upline_pt",
  soccer_others_account_pt : "@:ui.soccer @:ui.others @:ui.account_pt",
  soccer_others_upline_remaining : "@:ui.soccer @:ui.others @:ui.upline_remaining",
  soccer_others_account_min : "@:ui.soccer @:ui.others @:ui.account_min",
  hdp_mmo_upline_pt : "@:ui.hdp MMO @:ui.upline_pt",
  hdp_mmo_account_pt : "@:ui.hdp MMO @:ui.account_pt",
  hdp_mmo_upline_remaining : "@:ui.hdp MMO @:ui.upline_remaining",
  hdp_mmo_account_min : "@:ui.hdp MMO @:ui.account_min",
  slots_upline_pt : "@:ui.slots @:ui.upline_pt",
  slots_account_pt : "@:ui.slots @:ui.account_pt",
  slots_upline_remaining : "@:ui.slots @:ui.upline_remaining",
  slots_account_min : "@:ui.slots @:ui.account_min",
  soccer_min_bet: "@:ui.soccer @:ui.min_bet",
  soccer_max_bet: "@:ui.soccer @:ui.max_bet",
  soccer_max_per_match: "@:ui.soccer @:ui.max_per_match",
  slots: "Slots",
  security_update: "Update Security",
  security_code: "Security Code",
  success: "Success",
  stock: "Stock",
  special: "Special",
  special_announcements: "Special Announcements",
  seconds: "Seconds",
  security_disable: "Security Disabled",
  select_all: "Select All",
  system_parlay: "System Parlay",
  settlement_agent_bulk: "Settlement Agent Bulk",
  settlement_agent: "Settlement Agent",
  settle_agent: "Settlement Agent",
  settlement_member_bulk: "Settlement Member Bulk",
  settlement_member: "Settlement Member",
  settle_member: "Settlement Member",
  

  schedule_1: "Monday | Mon",
  schedule_2: "Tuesday | Tue",
  schedule_3: "Wednesday | Wed",
  schedule_4: "Thursday | Thu",
  schedule_5: "Friday | Fri",
  schedule_6: "Saturday | Sat",
  schedule_7: "Sunday | Sun",

  twtn: "To Win To Nil",
  total_outstanding: "Total Outstanding",
  target_id: "Target ID",
  target_action: "Target Action",
  total: "Total",
  types: "Types",
  total_goal: "Total Goal",
  tennis: "Tennis",
  today: "Today",
  thisweek: "This Week",
  thismonth: "This Month",
  transaction_log: "Transactions Log",
  total_bet: "Total Bet",
  transaction_date: "Transaction Date/Time",
  transfer_method: "Transfer Method",
  turnover: "Turnover",
  total_balance: "Total Balance",
  total_tran: "Total Transaction",
  total_base: "Total Member Bet",
  tennis_min_bet: "@:ui.tennis @:ui.min_bet",
  tennis_max_bet: "@:ui.tennis @:ui.max_bet",
  tennis_max_per_match: "@:ui.tennis @:ui.max_per_match",
  top_winner: "Top 10 Winner of the month",
  top_turnover: "Top 10 Highest Turnover of the month",
  top_loser: "Top 10 Loser of the month",
  type: "Type",
  total_downline: "Total Downline",
  to: "To",
  transfer: "Transfer",
  transfer_list: "Transfer List",
  transfer_history: "Transfer History",
  this_month: "This Month",
  this_week: "This Week",
  total_accepted: "Total Accepted",
  total_rejected: "Total Rejected",
  total_stake: "Total Stake",
  total_winlose: "Total Win/Lose",
  total_member: "Total Member",
  tournament: "Tournament",
  tournament_jackpot: "Tournament Jackpot",
  tournament_refund_list: "Tournament Refund List",

  under: "Under",
  upline_id: "Upline ID",
  unblock: "Unblock",
  update: "Update",
  username: "Username",
  update_commission_sb: "Commission Sportsbook",
  update_commission_lc: "Commission Livecasino",
  update_commission_sl: "Commission Slots",
  update_commission_lo: "Commission Lotto",
  update_commission_kn: "Commission Keno",
  update_commission_cf: "Commission ESports2",
  update_commission_lt: "Commission Lottery",
  update_bet_limit_lc: "Bet Limit Livecasino",
  update_bet_limit_sb: "Bet Limit Sportsbook",
  update_bet_limit_lo: "Bet Limit Lotto",
  update_bet_limit_kn: "Bet Limit Keno",
  update_bet_limit_cf: "Bet Limit ESports2",
  update_bet_limit_lt: "Bet Limit Lottery",
  update_position_sb: "Position Taking Sportsbook",
  update_position_lc: "Position Taking Livecasino",
  update_position_sl: "Position Taking Slots",
  update_position_lo: "Position Taking Lotto",
  update_position_kn: "Position Taking Keno",
  update_position_cf: "Position Taking ESports2",
  update_position_lt: "Position Taking Lottery",
  update_account: "Update Account",
  update_platform: "Update Platform",
  upline_pt: "Upline PT",
  upline_remaining: "Upline Remaining",
  unblock_profile: "Profile Unblock",
  unselect_all: "Un-select All",

  view_details: "View Details",
  view_downline: "View Downline",
  value: "Value",
  valid_turnover: "Valid Turnover",
  void: "Void",

  winlose_limit: "Win Lose Limit",
  wallet: "Wallet",
  winlose: "Win Lose",
  win_limit: "Win Limit",
  win_limit_multiplier: "Win Limit Multiplier",
  win_limit_tooltips: "Only applicable for Livecasino & Slots.",
  win_limit_tooltips1: "Due to Slot and Casino API latency, players may be able to continue betting for a few minutes after reaching Win Limit. ",
  win_limit_0: "Unlimited",
  win_limit_1: "Credit Limit x 1",
  win_limit_2: "Credit Limit x 2",
  win_limit_5: "Credit Limit x 5",
  win_limit_10: "Credit Limit x 10",
  win_limit_20: "Credit Limit x 20",
  winlose_column1: "W/L",
  winlose_column2: "Comm",
  winlose_today: "Win Lose Today",
  winlose_yesterday: "Win Lose Yesterday",
  winner: "Winner",
  won: "Won",
  win_half: "Won Half",
  withdrawal: "Withdrawal",
  
  yesterday: "Yesterday",
  yesterday_balance: "Yesterday Balance",

  provider_evo: "Evolution",
  provider_gp: "Game Play",
  provider_vivo: "Vivo suite",
  provider_sa: "SA Gaming",
  provider_ct: "CT855",
  provider_ptg: "Pretty Gaming",
  provider_yb: "Yeebet",
  "provider_pp-c": "Pragmatic",
  provider_lotto: "Lotto",
  provider_keno: "Keno",
  provider_cockfight: "ESports2",
  provider_lottery: "Lottery",
  provider_ar: "Arcadia Gaming",
  provider_slots: "Slots (Live22)",
  provider_pgs: "Slots (PGSoft)",
  provider_pp: "Slots (PP)",
  provider_jk: "Slots (Joker)",
  provider_sp: "Slots (SimplePlay)",
  provider_jili: "Slots (Jili)",
  provider_uu: "Slots (UU)",
  provider_db: "Slots (DBHash)",
  provider_wow: "Slots (WOW Gaming)",
  provider_ai: "AI Livecasino",
  provider_wf: "Slots (WF Gaming)",
  provider_next: "Slots (Next)",
  provider_dbp: "Poker (DBHash)",
  provider_epw: "Poker (Epicwin)",
  provider_sexybcrt: "Sexy Baccarat",

  timer: "Timer",
  no_refresh: "No refresh",
  actual_yesterday_balance: "Actual Yesterday Balance",

  loading: "Loading...",
  slide_puzzle: "Slide the puzzle",
  drag_to_verify: "Drag to verify",
  running_score: "Running Score",
  unblock_account: "Unblock Account",
  password_expired: "Password Expired",

  lotto_upline_pt : "@:ui.lotto @:ui.upline_pt",
  lotto_account_pt : "@:ui.lotto @:ui.account_pt",
  lotto_upline_remaining : "@:ui.lotto @:ui.upline_remaining",
  lotto_account_min : "@:ui.lotto @:ui.account_min",
  keno_upline_pt : "@:ui.keno @:ui.upline_pt",
  keno_account_pt : "@:ui.keno @:ui.account_pt",
  keno_upline_remaining : "@:ui.keno @:ui.upline_remaining",
  keno_account_min : "@:ui.keno @:ui.account_min",
  cockfight_upline_pt : "@:ui.cockfight @:ui.upline_pt",
  cockfight_account_pt : "@:ui.cockfight @:ui.account_pt",
  cockfight_upline_remaining : "@:ui.cockfight @:ui.upline_remaining",
  cockfight_account_min : "@:ui.cockfight @:ui.account_min",
  lottery_upline_pt : "@:ui.lottery @:ui.upline_pt",
  lottery_account_pt : "@:ui.lottery @:ui.account_pt",
  lottery_upline_remaining : "@:ui.lottery @:ui.upline_remaining",
  lottery_account_min : "@:ui.lottery @:ui.account_min",
  livecasino_tooltips: "Notice: Bet limits are not applicable to <b>Evolution Casino</b>",
  notice: "Notice"
};